import { lazy } from 'react'

export default {
    path: '/permessi/:permessoId',
    title: 'Permesso: {{params.permessoId}}',
    component: lazy(() => import('./detail')),
}